export const HIGHLIGHT = `color: hotpink; background-color: black; border-radius: 0.25em`
